import { sqWorkbookStore } from '@/core/core.stores';
import { useFluxPaths } from '@/core/hooks/useFluxPaths.hook';
import type { WorkbookApprovalFlowStep } from '@/worksheet/worksheet.types';

export const useApprovalFlows = () => {
  const { approvalFlows, approvalFlowAssignments } = useFluxPaths(sqWorkbookStore, [
    'approvalFlows',
    'approvalFlowAssignments',
  ]);
  // Initial implementation assumes there would only 1 approvalFlows per server.
  const approvalFlow = approvalFlows[0];
  const pendingApprovalSteps = approvalFlow?.steps?.filter(
    ({ status }: WorkbookApprovalFlowStep) => status === 'PENDING',
  );

  const approvedSteps = approvalFlow?.steps?.filter(({ status }: WorkbookApprovalFlowStep) => status === 'APPROVED');

  const nextStep = pendingApprovalSteps?.[0];

  const shouldDisableLock = Boolean(approvalFlow) && approvedSteps?.length !== 0 && !nextStep?.lockRequired;

  return {
    shouldDisableLock,
    approvedSteps,
    pendingApprovalSteps,
    approvalFlow,
    approvalFlowAssignments,
  };
};
